<template>
  <div class="card">
    <div class="card-content">
      <table class="">
        <tr>
          <th>ID</th>
          <th>Nome</th>
          <th>Numero Polizza</th>
          <th>Categoria</th>
          <th>Inizio validità</th>
          <th>Fine Validità</th>
          <th>Verificato</th>
<!--          <th>Stato</th>-->
        </tr>

        <tr
            v-for="(insurance, i) in showedInsurances" :key="insurance.id">
          <td>
            <span>{{ insurance.id }}</span>
            <button class="btn-flat" @click="openModal(insurance.id)">
              <i class="material-icons">edit</i> /
              <i class="material-icons">visibility</i>
            </button>

          </td>
          <td>{{ insurance.title }}</td>
          <td>{{ insurance.code }}</td>
          <td>{{ insurance.type_name }}</td>
          <td>{{ new Date(insurance.valid_from).toLocaleDateString('it-IT') }}</td>
          <td>{{ new Date(insurance.valid_to).toLocaleDateString('it-IT') }}</td>
          <td>
            <span v-if="insurance.verified === '1'">Verificata</span>
            <span v-if="insurance.verified === '0'">In attesa</span>
          </td>
<!--          <td>{{ insurance.published }}</td>-->
        </tr>

      </table>

      <MaterializecssModal
        type="bottom-sheet"
        ref="modal"
        :opened="infoModal"
        :triggerIcon="!infoModal ? 'open_in_new' : 'close'"
        :triggerText="!infoModal ? 'Apri' : 'Chiudi'"
        :triggerClasses="['btn','purple']"
        :showTrigger="false"
        :show-close-modal="false"
        @closeEnd="infoModal = false"
        :other-classes="['fixed-header']"
      >

        <AsdInsurance
            v-if="selectedInsuranceId > 0"
            :key="selectedInsuranceId"
            :insurance="selectedInsurance"
            :validation="validation"
            @close="$refs.modal.close()"
          />

        <template v-slot:header>
          <h2>Dettagli polizza</h2>
          <span style="width: 100%">&nbsp;</span>
          <button type="button" class="btn red" @click="$refs.modal.close()">Chiudi</button>
        </template>
      </MaterializecssModal>

    </div>
    <div class="card-action">
      <a class="btn green" :href="'/index.php?option=com_asdgest&view=insurance&layout=new&new='+group_id">Aggiungi</a>

      <div class="switch" style="display: inline-block; margin-left: 30px">
        <label>
          Nascondi scadute
          <input type="checkbox" @input="showExpired = !showExpired">
          <span class="lever"></span>
          Mostra scadute
        </label>
      </div>
    </div>
  </div>

</template>

<script>

import Vue from 'vue';

export default {
  name: "AsdInsurances",
  props: {
    insurances: {
      required: true,
      type: Array
    },
    group_id: {
      required: true,
      type: Number,
    },
    validation: {
      required: true,
      type: Number
    }
  },

  data() {
    return {
      file_types: {
        'certificate': {
          label: 'Certificato assicurativo',
          description: 'Carica un file che '
        },
        'receipt': {
          label: '',
          description: ''
        },
        'policy': {},
      },

      selectedInsuranceId: 0,
      selectedInsurance: null,

      infoModal: false,
      showExpired: false,
    }
  }
  ,

  methods: {
    openModal: function(i) {
      console.log(i, this.insurances)
      let data;
      this.insurances.forEach( x => {
        if (x.id === i)
          data = x;
      });
      if (!data) {
        console.log('Modal of that insurance does not exists');
        return;
      }
      Vue.set(this,'selectedInsurance',data);
      this.selectedInsuranceId = data.id;
      this.$refs.modal.open();
    },

    verifiedStatus: function(status) {
      let number = parseInt(status);
      switch(status) {
        case 1:
          return 'Verificato';
        case 0:
          return 'In attesa di verifica';
        default:
          return '??';
      }
    }
  },

  computed: {
    showedInsurances: function() {
      if (!this.showExpired) {
        return this.insurances.filter( x => {
          let now = new Date();
          let valid_to = new Date(x.valid_to);
          return ( now.getTime() - valid_to.getTime() ) < 0
        })
      }
      return this.insurances;
    }
  }
}
</script>

<style scoped>

</style>
